import NotFound from 'modules/website/components/NotFound/NotFound'
import React from 'react'

export default function NotFoundView() {
  return (
    <NotFound />
  )
}
